import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RmSidebarComponent } from '../common/rm-sidebar/rm-sidebar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProjectsComponent } from './projects/projects.component';
import { TimesheetApprovalsComponent } from './timesheet-approvals/timesheet-approvals.component';
import { PlannedActualComponent } from './planned-actual/planned-actual.component';
import { DeligateComponent } from './deligate/deligate.component';
import { PendingtimesheetDetailsComponent } from './timesheet-approvals/pendingtimesheet-details/pendingtimesheet-details.component';
import { TimesheetEntryComponent } from './timesheet-entry/timesheet-entry.component';
import { RmGuard } from './rm.guard';
import { EmployeeComponent } from './employee/employee.component';
import { NotificationComponent} from '../common/notification/notification.component';
import { AddDeligateComponent } from './deligate/add-deligate/add-deligate.component';
import { PlanedActualComponent } from '../admin/planed-actual/planed-actual.component';
import { ApprovalListComponent } from './timesheet-approvals/approval-list/approval-list.component';
import { RejectedTimesheetDetailsComponent } from './timesheet-approvals/rejected-timesheet-details/rejected-timesheet-details.component';
import { OrganizationalReportComponent } from './organizational-report/organizational-report.component';
import { MyReportComponent } from './my-report/my-report.component';
import { ProfileComponent } from '../common/profile/profile.component';
import { NonAdherenceListComponent } from './non-adherence-list/non-adherence-list.component';
import { NonComplianceListComponent } from './non-compliance-list/non-compliance-list.component';
import { TimesheetReportComponent } from './timesheet-report/timesheet-report.component';

const routes: Routes = [
  {
    path: 'rm',
    component: RmSidebarComponent,
    canActivate: [RmGuard],
    canActivateChild: [RmGuard],
    children: [
      {
        path: '',
        component: DashboardComponent
      },
       {
        path: 'planed-actual',
        component: PlanedActualComponent,
      },
      {
        path: 'profile',
        component: ProfileComponent,
      },
      {
        path: 'approval-list',
        component: ApprovalListComponent,
      },
      {
        path: 'rejected-list',
        component: RejectedTimesheetDetailsComponent,
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'notification',
        component: NotificationComponent,
      },
      {
        path: 'projects',
        component: ProjectsComponent,
      },
      {
        path: 'employee',
        component: EmployeeComponent,
        canActivateChild: [RmGuard]
      },
      {
        path: 'organizational-report',
        component: OrganizationalReportComponent,
        canActivateChild: [RmGuard]
      },
      {
        path: 'my-report',
        component: MyReportComponent,
        canActivateChild: [RmGuard]
      },
      {
        path: 'timeSheetApprovals',
        component: TimesheetApprovalsComponent,
        children: [
          {
            path: 'viewtimesheetDetails',
            component: PendingtimesheetDetailsComponent
          }]
      },
      {
        path: 'viewtimesheetDetails',
        component: PendingtimesheetDetailsComponent
      },
      {
        path: 'viewdelegate',
        component: DeligateComponent,
      },
      {
        path: 'delegate',
        component: AddDeligateComponent,
      },
      {
        path: 'plannedActual',
        component: PlannedActualComponent,
      },
      {
        path: 'timesheet-entry',
        component: TimesheetEntryComponent,
      },
      {
        path: 'timesheet-report',
        component: TimesheetReportComponent,
      },
      {
        path: 'non-compliance-list',
        component: NonComplianceListComponent,
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RmRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/rm/rm-routing.module.ts